module.exports = __webpack_public_path__ + "img/newsIndImg3.7037c9b9.png";